import { useCallback } from "react";

import { useNavigate } from "..";
import { useDealActions } from "../../store";
import { INotification } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";

export function useCharacteristicHook(): NotificationHandlerType {
  const { setCharacteristicsManageAction } = useDealActions();
  const navigate = useNavigate();

  return useCallback(async ({ components }: INotification) => {
    if (components.deal_id && components.characteristic_id && components.deal_title) {
      navigate({ route: "dealDashboard", params: { deal_id: components.deal_id } });
      setCharacteristicsManageAction({
        dealId: components.deal_id,
        dealName: components.deal_title,
        viewOnly: false
      });
    }
  }, []);
}
